import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRedoDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconArrowRedoDown"><Path d="M18 19L20.9393 16.0607C21.5251 15.4749 21.5251 14.5251 20.9393 13.9393L18 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M20 15L7.375 15C4.82068 15 2.75 12.9293 2.75 10.375C2.75 7.82068 4.82068 5.75 7.375 5.75L12.25 5.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconArrowRedoDown;
